import * as React from "react";

import {consumeContext}     from "@Common/react/context";
import {cs}                 from "@Common/react/chain-services";
import {AccountTabsLayout}  from "../../../common/account-tabs-layout/account-tabs-layout";

export const ReportsLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    ({accountMenu}, next) => AccountTabsLayout({
        activeMenu: "reports",
        activeTab,
        config: reportSubMenu(accountMenu),
        next,
    }),
    () => (
        <div className="reports-layout-5go">
            {next()}
        </div>
    ),
);

const reportSubMenu = (accountMenu) => {
    const reportsMenu = accountMenu?.adminDropdownMenu?.dropdownItems?.find((item) => item.configPath === "reportsMenu")
    return reportsMenu?.subMenu || reportSubMenuDefault
}

const reportSubMenuDefault = [
    {
        linkLabel: "Detailed Transaction Report",
        name: "transaction",
        link: "/account/admin/reports/transaction",
    },
    {
        linkLabel: "Activity Dashboard",
        name: "activity-dashboard",
        link: "/account/admin/reports/activity-dashboard",
    }
];
